import {
  FiThumbsUp,
  FiMessageCircle,
  FiShare2,
  FiChevronUp,
  FiChevronDown,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import api from "../../utils/api";

export default function ShortsOverlay({
  data,
  currentUser,
  onOpenComments,
  onScrollUp,
  onScrollDown,
}) {
  const navigate = useNavigate();
  const THEME_COLOR = "#ff4d6d";

  const videoId = data?._id;
  const isMobile = window.innerWidth <= 768;

  /* ================= STATE SYNC ================= */

  const [liked, setLiked] = useState(data?.isLike ?? false);
  const [likes, setLikes] = useState(data?.like ?? 0);

  useEffect(() => {
    setLiked(data?.isLike ?? false);
    setLikes(data?.like ?? 0);
  }, [data]);

  const comments = data?.totalComments ?? 0;
  const shares = data?.shareCount ?? 0;

  /* ================= LIKE ================= */

  const handleLike = async (e) => {
    e.stopPropagation();

    if (!currentUser?._id) {
      navigate("/login");
      return;
    }

    const previousLiked = liked;
    const newLiked = !previousLiked;

    // Optimistic update
    setLiked(newLiked);
    setLikes((prev) =>
      newLiked ? prev + 1 : Math.max(prev - 1, 0)
    );

    try {
      await api.post("/client/video/likeOrDislikeOfVideo", null, {
        params: {
          userId: currentUser._id,
          videoId,
          likeOrDislike: "like",
        },
      });
    } catch {
      // rollback
      setLiked(previousLiked);
      setLikes((prev) =>
        newLiked ? Math.max(prev - 1, 0) : prev + 1
      );
    }
  };

  /* ================= COMMENT ================= */

  const handleComment = (e) => {
    e.stopPropagation();

    if (!currentUser?._id) {
      navigate("/login");
      return;
    }

    onOpenComments?.(videoId);
  };

  /* ================= SHARE ================= */

  const handleShare = async (e) => {
    e.stopPropagation();

    const shareUrl = `${window.location.origin}/shorts/${videoId}`;

    try {
      if (navigator.share) {
        await navigator.share({
          title: data?.title || "Watch this short",
          url: shareUrl,
        });
      } else {
        await navigator.clipboard.writeText(shareUrl);
        alert("Link copied!");
      }

      await api.post("/client/video/shareCount", null, {
        params: {
          userId: currentUser?._id || null,
          videoId,
        },
      }).catch(() => {});
    } catch {}
  };

  /* ================= STYLES ================= */

  const circleBtn = {
    width: 48,
    height: 48,
    borderRadius: "50%",
    background: "rgba(0,0,0,0.65)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: 20,
    color: "#fff",
    backdropFilter: "blur(4px)",
  };

  const navBtn = {
    width: 48,
    height: 48,
    borderRadius: "50%",
    background: THEME_COLOR,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#fff",
    fontSize: 20,
    border: "none",
  };

  /* ================= POSITION ================= */

  const wrapperStyle = isMobile
    ? {
        position: "absolute",
        right: 12,
        top: "50%",
        transform: "translateY(-50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 18,
        zIndex: 30,
      }
    : {
        position: "absolute",
        right: -70,
        top: "50%",
        transform: "translateY(-50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 18,
        zIndex: 30,
      };

  /* ================= RENDER ================= */

  return (
    <div style={wrapperStyle}>
      {/* LIKE */}
      <div
        style={{
          ...circleBtn,
          color: liked ? THEME_COLOR : "#fff",
        }}
        onClick={handleLike}
      >
        <FiThumbsUp />
      </div>
      <div style={{ fontSize: 12, color: "#fff" }}>{likes}</div>

      {/* COMMENT */}
      <div style={circleBtn} onClick={handleComment}>
        <FiMessageCircle />
      </div>
      <div style={{ fontSize: 12, color: "#fff" }}>{comments}</div>

      {/* SHARE */}
      <div style={circleBtn} onClick={handleShare}>
        <FiShare2 />
      </div>
      <div style={{ fontSize: 12, color: "#fff" }}>{shares}</div>

      {/* SPACING */}
      <div style={{ height: 10 }} />

      {/* NAVIGATION */}
      <button style={navBtn} onClick={onScrollUp}>
        <FiChevronUp />
      </button>

      <button style={navBtn} onClick={onScrollDown}>
        <FiChevronDown />
      </button>
    </div>
  );
}
